<div class="row"> 
   <div class="col-sm-4"> 
    <app-coin [data]="Bitcoin"></app-coin>
   </div>
   <div class="col-sm-4"> 
    <app-coin [data]="Ethereum"></app-coin>
   </div>
   <div class="col-sm-4"> 
    <app-coin [data]="LeaveTravel"></app-coin>
   </div>
   <div class="col-xl-12"> 
     <app-market-graph></app-market-graph>
   </div>
   <div class="col-xl-12">
     <app-currencies></app-currencies>
   </div>
   <div class="col-sm-6"> 
     <app-buy-coins></app-buy-coins>
   </div>
   <div class="col-sm-6"> 
    <app-sell-coins></app-sell-coins>
   </div>
 </div>